<template>
  <router-link
    tag="tr"
    :to="{
      name: 'ProjectsProjectShow',
      params: { id: item.project_work_type.project.id },
    }"
    class="employee"
  >
    <td>
      {{ item.project_work_type.project.name }}
    </td>
    <td>
      {{ item.project_work_type.work_type.name }}
    </td>
    <td>
      {{ $formatDate(item.start_date) + ' - ' + $formatDate(item.end_date) }}
    </td>
    <td>
      <div class="employees">
        <template v-for="(employee, index) in item.employees">
          <EmployeesTooltip :employee="employee" :key="index" />
        </template>
      </div>
    </td>
    <td>
      <div class="buttons">
        <EmployeesGroupSelectModalWorkTypeExtra :create="false" :id="item.id" :item="item"/>
        <DeleteModal
          type="workClientProjectsWorkTypePeriod"
          :item="item"
          :text="
            localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project-delete'
            ].text
          "
          :textSecond="
            localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project-delete'
            ].text_second
          "
          :textCheckbox="localStorage.translations.pages.common.checkbox.delete_along_with_reports"
        />
      </div>
    </td>
  </router-link>
</template>

<script>
import EmployeesTooltip from 'components/employees/EmployeesTooltip'
import EmployeesGroupSelectModalWorkTypeExtra from 'components/employees/group/select/EmployeesGroupSelectModalWorkTypeExtra'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'EmployeesGroupTableItem',
  components: {
    EmployeesTooltip,
    DeleteModal,
    EmployeesGroupSelectModalWorkTypeExtra,
  },
  props: { item: Object },
}
</script>

<style lang="scss" scoped>
tr {
  cursor: pointer;
}
</style>
